import { render, staticRenderFns } from "./AsignacionClienteGpsPantalla.vue?vue&type=template&id=d9ceba12&"
import script from "./AsignacionClienteGpsPantalla.vue?vue&type=script&lang=ts&"
export * from "./AsignacionClienteGpsPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports